<!-- Section Général -->
<app-collapse
  [title]="'P00080.status.general' | translate"
  [warning]="doBinaireOperation(getValue('alSSwitchK2Debit'), 0, 1) === 0"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00080.status.general.sourcedebit' | translate"
      [warning]="
        doBinaireOperation(getValue('alSSwitchK2Debit'), 0, 1) === 0
          ? true
          : false
      "
      [ctaText]="
        doBinaireOperation(getValue('alSSwitchK2Debit'), 0, 1) === 0
          ? ('P00080.status.general.sourcedebit.cta' | translate)
          : ''
      "
      [icon]="'fa-exclamation-triangle'"
      [notWarning]="'P00080.status.ok' | translate"
    />

    <app-display-rubrique-status
      [title]="'P00080.status.general.detectiondebit' | translate"
      [value]="
        doBinaireOperation(getValue('alSSwitchK2Debit'), 5, 1) === 1
          ? ('P00080.status.general.detectiondebit.yes' | translate)
          : ('P00080.status.general.detectiondebit.no' | translate)
      "
    />

    <app-display-rubrique-status
      [title]="'P00080.status.general.senscontact' | translate"
      [value]="
        doBinaireOperation(getValue('alSSwitchK2Debit'), 1, 1) === 1
          ? ('P00080.status.general.senscontact.no' | translate)
          : ('P00080.status.general.senscontact.nf' | translate)
      "
    />
  </div>
</app-collapse>

<!-- Section Bidon -->
<app-collapse
  [title]="'P00080.status.bidon' | translate"
  [warning]="
    getValue('alSEtatRxBottomOfTank') === 1 ||
    getValue('alSEtatRxMaxDosingTime') === 1 ||
    getValue('alSEtatPhBottomOfTank') === 1 ||
    getValue('alSEtatPhMaxDosingTime') === 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00080.status.bidon.rx' | translate"
      [warning]="getValue('alSEtatRxBottomOfTank') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00080.status.ok' | translate"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00080.status.bidon.ph' | translate"
      [warning]="getValue('alSEtatPhBottomOfTank') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00080.status.ok' | translate"
    />

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00080.status.bidon.surdosagerx' | translate"
      [warning]="getValue('alSEtatRxMaxDosingTime') === 1"
      [ctaText]="
        getValue('alSEtatRxMaxDosingTime') === 1
          ? ('P00080.status.bidon.surdosagerx.cta' | translate)
          : null
      "
      [notWarning]="'P00080.status.ok' | translate"
      [pressable]="false"
    />

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00080.status.bidon.surdosageph' | translate"
      [warning]="getValue('alSEtatPhMaxDosingTime') === 1"
      [ctaText]="
        getValue('alSEtatPhMaxDosingTime') === 1
          ? ('P00080.status.bidon.surdosageph.cta' | translate)
          : null
      "
      [notWarning]="'P00080.status.ok' | translate"
      [pressable]="false"
    />

    <app-display-rubrique-status-on-off
      [title]="'P00080.status.bidon.rx.state' | translate"
      [value]="getValue('alSEtatRxDosingInProgress') !== 0"
    />

    <app-display-rubrique-status-on-off
      [title]="'P00080.status.bidon.ph.state' | translate"
      [value]="getValue('alSEtatPhDosingInProgress') !== 0"
    />
  </div>
</app-collapse>

<!-- Section Désinfection -->
<app-collapse
  [title]="'P00080.status.desinfection' | translate"
  [warning]="
    getValue('alSEtatRxLowAlarmThresholdCrossed') === 1 ||
    getValue('alSEtatRxHighAlarmThresholdCrossed') === 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00080.status.desinfection.rx.mesure' | translate"
      [value]="(getValue('alSMesureRx') / 100).toFixed(0) + ' mV'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P00080.status.desinfection.rx.automaintien' | translate"
        [value]="getValue('alSMiseRouteFiltrationRx') !== 0"
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P00080.status.desinfection.rx.mesure.low' | translate"
      [warning]="getValue('alSEtatRxLowAlarmThresholdCrossed') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00080.status.ok' | translate"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00080.status.desinfection.rx.mesure.high' | translate"
      [warning]="getValue('alSEtatRxHighAlarmThresholdCrossed') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00080.status.ok' | translate"
    />
  </div>
</app-collapse>

<!-- Section Traitement pH -->
<app-collapse
  [title]="'P00080.status.desinfectionph' | translate"
  [warning]="
    getValue('alSEtatPhLowAlarmThresholdCrossed') === 1 ||
    getValue('alSEtatPhHighAlarmThresholdCrossed') === 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00080.status.desinfection.ph.mesure' | translate"
      [value]="(getValue('alSMesurePh') / 100).toFixed(1) + ' pH'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P00080.status.desinfection.ph.automaintien' | translate"
        [value]="getValue('alSMiseRouteFiltrationPh') !== 0"
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P00080.status.desinfection.ph.mesure.low' | translate"
      [warning]="getValue('alSEtatPhLowAlarmThresholdCrossed') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00080.status.ok' | translate"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00080.status.desinfection.ph.mesure.high' | translate"
      [warning]="getValue('alSEtatPhHighAlarmThresholdCrossed') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00080.status.ok' | translate"
    />
  </div>
</app-collapse>

<!-- Section Produit -->
<app-collapse
  [title]="'P00080.status.produit' | translate"
  [warning]="presenceProduit === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00080.status.connexionProduit' | translate"
      [warning]="presenceProduit !== 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00080.status.ok' | translate"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00080.status.compteur' | translate"
        [value]="getValue('alSCompteurBouton') + ''"
      />
    }
  </div>
</app-collapse>
